import { render, staticRenderFns } from "./OrginationPositionView.vue?vue&type=template&id=4d1c856f&scoped=true"
import script from "./OrginationPositionView.vue?vue&type=script&lang=js"
export * from "./OrginationPositionView.vue?vue&type=script&lang=js"
import style0 from "./OrginationPositionView.vue?vue&type=style&index=0&id=4d1c856f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1c856f",
  null
  
)

export default component.exports